import type { StatusColors } from '@nexelem/components';
import { SimulationListStatusView } from '@nexelem/graphne-api';

type SimulationStatusSettings = {
  color: StatusColors;
  label: keyof typeof SimulationListStatusView;
};

const statusMap: Record<SimulationListStatusView, SimulationStatusSettings> = {
  [SimulationListStatusView.New]: { color: 'yellow', label: 'New' },
  [SimulationListStatusView.InProgress]: { color: 'blue', label: 'InProgress' },
  [SimulationListStatusView.Complete]: { color: 'green', label: 'Complete' },
  [SimulationListStatusView.Error]: { color: 'red', label: 'Error' },
};

export const simulationStatusMap = (status: SimulationListStatusView): SimulationStatusSettings | undefined =>
  statusMap[status];
